'use client';

import { useEffect } from "react";
function useToastManagerInit(toastManager, stateSetter, onBeforeStateChange) {
  useEffect(() => {
    toastManager.init((setterFn) => {
      onBeforeStateChange();
      stateSetter(setterFn);
    });
    return () => {
      toastManager.detach();
    };
  }, []);
}
export {
  useToastManagerInit
};
